import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class SupportedOrder extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/supported/order`)
  }

  upsertCourier(model, showProgress) {
    return this._request({
      action: 'upsert/courier',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  upsertCarType(model, showProgress) {
    return this._request({
      action: 'upsert/carType',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  upsertLoad(model, showProgress) {
    return this._request({
      action: 'upsert/load',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  upsertPoiCategory(model, showProgress) {
    return this._request({
      action: 'upsert/poiCategory',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  upsertCarCategory(model, showProgress) {
    return this._request({
      action: 'upsert/carCategory',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  upsertAddon(model, showProgress) {
    return this._request({
      action: 'upsert/addon',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  upsertLoadCondition(model, showProgress) {
    return this._request({
      action: 'upsert/loadCondition',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  upsertCourierLoadTypes(model, showProgress) {
    return this._request({
      action: 'upsert/rangeType/courier',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  upsertDriverLoadTypes(model, showProgress) {
    return this._request({
      action: 'upsert/rangeType/driver',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  loadConditionList(filter, showProgress) {
    return this._request({
      action: 'loadCondition/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
